import { createApiRef } from '@backstage/core-plugin-api';
import { TemplateDetails } from '../../types/details';
import { Entity } from '@backstage/catalog-model';

export const detailsApiRef = createApiRef<DetailsApi>({
  id: 'plugin.metrics-alerting-insights.details.service',
});

export interface DetailsApi {
  retrieveDetailsInfo: (entity: Entity) => Promise<TemplateDetails>;
}
